import React, { useEffect } from "react";
import { useField } from "formik";
import { Form, InputGroup } from "react-bootstrap";
import AwesomeIcon from "@icons/AwesomeIcon";

interface InputDateProps {
  name: string;
  handleChange?: (value: string) => void;
  type?: "date" | "datetime-local" | "time" | "month";
}

const InputDate: React.FC<InputDateProps> = ({
  name,
  handleChange,
  type = "date",
}) => {
  const [field, meta] = useField(name);

  useEffect(() => {
    if (handleChange) {
      handleChange(field.value);
    }
  }, [field.value, handleChange]);

  let formGroupClass = "";
  if (meta && meta.touched) {
    if (meta.error) {
      formGroupClass = "is-invalid";
    } else {
      formGroupClass = "is-valid";
    }
  }

  return (
    <InputGroup>
      <Form.Control
        className={`${formGroupClass}`}
        {...field}
        value={field.value}
        style={{ position: "relative" }}
        type={type}
      />
      <InputGroup.Text>
        <AwesomeIcon icon={["far", "calendar-days"]} />
      </InputGroup.Text>
      <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
    </InputGroup>
  );
};

export default InputDate;